import { render, staticRenderFns } from "./DraftConflictDialog.vue?vue&type=template&id=151ef745&scoped=true"
import script from "./DraftConflictDialog.vue?vue&type=script&lang=js"
export * from "./DraftConflictDialog.vue?vue&type=script&lang=js"
import style0 from "./DraftConflictDialog.vue?vue&type=style&index=0&id=151ef745&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ef745",
  null
  
)

export default component.exports